import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import Select from 'react-select';
import { resourcesConfigurationRoute,usersProfile,resourcesGeofence } from '../../helpers/backend_helper';
import { getStorageCompany } from '../../helpers/api_helper';
import {Alert} from '../../helpers/alerts/alertHelper';
import Validate from './Validate'

const AddUpdModal = ({modal,setModal,items, setItems, setItem,item,authUser,id}) => {
	console.log(item)
	const company = getStorageCompany();
	const [selects, setSelects] = useState({
		providers:[{id:0,name:''}],
		groups:[{id:0,name:''}],
		administrators:[{id:0,name:'no selected'},{id:1,name:'d selected'}],	
	});
	const [ geofences, setGeofences ] = useState([]);
	const [ errors, setErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const handleClose = () => {
		setModal({...modal,show:false,update:false});
		setItem( {...item,
    		id: 0,
	        departure:0,
	        platform_price:0,
	        pasage_price:0,
	        max_speed:0,
	        lock:false,
	        active:false,
	        geofence:null,
	        geofence_id:null,
	        route_id:id
    	});	
    }

    const handlerOnChange = (value,name) => {
    	if(name=='geofence'){
			setItem({...item, ['geofence_id']:value.id,[name]:value});
    	}else{
    		setItem({...item, [name]:value});
    	}
    }

    const save = () => {
    	setErrors([])
    	const validate = Validate(item);
    	if(validate != undefined){
            setErrors(validate);
            console.log(validate)
            setLoading(false)
            return;
        }
    	setLoading(true)
    	if(modal.update){
    		resourcesConfigurationRoute('put',item,item.id).then(response => {
    			responseAction(response);			
    		})
    	}else{
    		resourcesConfigurationRoute('post',item).then(response => {
    			responseAction(response);
    		})	
    	}

    }

    const responseAction = (response) => {
    	if(response.status){
    		const newItem = response.config;
    		let array = [];
    		if(modal.update){
    			array = items.map(item => item.id !== newItem.id ? item : newItem);
    		}else{
    			array = [...items, newItem];
    			array.sort((a, b) => {
    				return a.id - b.id;
    			});
    		}
    		setItems(array);
			handleClose()
			setLoading(false)
    	}else{
    		setLoading(false)
    		setErrors(response.response.data.errors)
    	}
    }

    useEffect(() => {
    	resourcesGeofence('show',{},id).then(response => {
    		console.log(response)
    		setGeofences(response.geofences)
    	});
    }, [])


    return (
		<div>
	        <Modal isOpen={modal.show} className="modal-dialog modal-lg">
				<ModalHeader className="bg-primary">Configuracion de Ruta</ModalHeader>
				<ModalBody>
				<div className="row">
					<div className="col-sm-4">
					    <label className="form-label">Primera Hora de Salida:</label>
					    <input className="form-control" name="departure" type="time" onChange={ e => handlerOnChange(e.target.value,'departure') } value={item.departure}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.departure && errors.departure[0]}</div>
					    }
					</div>

					<div className="col-sm-8">
					    <label className="form-label">Geocerca Intermedia:</label>
					    <Select
							className="basic-single"
							classNamePrefix="select"
							defaultValue={item.geofence}
							isSearchable={true}
							getOptionLabel={(option) => `${option.name}`}
							getOptionValue={(option) => `${option.id}`}
							name="color"
							options={geofences}
							onChange={ e => [handlerOnChange(e, 'geofence')] }
						/>
					    {
					    	errors && <div className="form-text text-danger">{errors.geofence_id && errors.geofence_id[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Pago de plataforma:</label>
					    <input className="form-control" name="platform_price" type="number" onChange={ e => handlerOnChange(e.target.value,'platform_price') } value={item.platform_price}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.platform_price && errors.platform_price[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Velocidad Máxima:</label>
					    <input className="form-control" name="max_speed" type="number" onChange={ e => handlerOnChange(e.target.value,'max_speed') } value={item.max_speed}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.max_speed && errors.max_speed[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Precio del pasaje:</label>
					    <input className="form-control" name="pasage_price" type="number" onChange={ e => handlerOnChange(e.target.value,'pasage_price') } value={item.pasage_price}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.pasage_price && errors.pasage_price[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Bloquear Cambio de Salidas(5 min):</label>
					    <Select
							className="basic-single"
							classNamePrefix="select"
							isClearable={true}
							defaultValue={item.lock}
							isSearchable={true}
							name="color"
							options={[{label:'Si',value:true},{label:'No',value:false}]}
							onChange={ e => [handlerOnChange(e.value, 'lock')] }
						/>
					    {
					    	errors && <div className="form-text text-danger">{errors.lock && errors.lock[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Alias:</label>
					    <input className="form-control" name="alias" type="text" onChange={ e => handlerOnChange(e.target.value,'alias') } value={item.alias}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.alias && errors.alias[0]}</div>
					    }
					</div>
					<div className="col-sm-4">
					    <label className="form-label">Horas de muestra:</label>
					    <input className="form-control" name="hours" type="number" onChange={ e => handlerOnChange(e.target.value,'hours') } value={item.hours}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.hours && errors.hours[0]}</div>
					    }
					</div>
					

					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={save} disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } 
						Guardar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}>Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default AddUpdModal;